import { Grid } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import Image from 'components/medias/Image';
import error from 'assets/images/illustrations/error.svg';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  container: {
    left: '50%',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
  },
  errorContainer: {
    textAlign: 'center',
  },
  title: {
    fontSize: '3em',
    fontWeight: 'bold',
    padding: 50,
  },
}), { name: 'OfflinePage' });

const OfflinePage = (): JSX.Element => {
  const classes = useStyles();

  return (
    <Grid className={classes.container} container>
      <Grid className={classes.errorContainer} item xs={12}>
        <div className={classes.title}>
          <FormattedMessage id="offline_page.title" />
        </div>
      </Grid>

      <Grid item xs={4} />
      <Grid item xs={4}>
        <Image src={error} />
      </Grid>
      <Grid item xs={4} />
    </Grid>
  );
};

export default OfflinePage;
